import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../updObject';

const initialState = {
    token: null,
    userFullname: null,
    user: {},
    error: null,
    loading: false,
    loadingStatus: false,
    authRedirectPath: '/',
    mfaRequired: null,
    mfaTotpSecret: null,
    mfaEnrollUsername: null
};

const authStartChecking = ( state, action ) => {
    return updateObject( state, { loadingStatus: true } );
};

const authStart = ( state, action ) => {
    return updateObject( state, { error: null, loading: true } );
};

const checkFail = (state, action) => {
    return updateObject( state, {
        loadingStatus: false,
        mfaRequired: null,
        mfaTotpSecret: null,
        mfaEnrollUsername: null
    });
};

const authSuccess = (state, action) => {
    return updateObject( state, { 
        token: action.token,
        user: action.user,
        userFullname: action.userFullname,
        error: null,
        loading: false,
        loadingStatus: false,
        mfaRequired: null,
        mfaTotpSecret: null,
        mfaEnrollUsername: null,
     } );
};

const authFail = (state, action) => {
    return updateObject( state, {
        error: action.error,
        loading: false,
        mfaRequired: null,
        mfaTotpSecret: null,
        mfaEnrollUsername: null
    });
};

const authMfaRequired = (state, action) => {
    return updateObject(state, {
        mfaRequired: action.challengeName,
        mfaTotpSecret: null,
        mfaEnrollUsername: null,
        loading: false,
        error: null
    });
};

const authMfaSetupReady = (state, action) => {
    return updateObject(state, {
        mfaTotpSecret: action.secret,
        mfaEnrollUsername: action.enrollUsername || null,
        loading: false,
        error: null
    });
};

const authMfaCancel = (state, action) => {
    return updateObject(state, {
        mfaRequired: null,
        mfaTotpSecret: null,
        mfaEnrollUsername: null,
        loading: false,
        error: null
    });
};

const authMfaSubmitFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    });
};

const authLogout = (state, action) => {
    return updateObject(state, {
        token: null,
        user: {},
        userFullname: null,
        mfaRequired: null,
        mfaTotpSecret: null,
        mfaEnrollUsername: null
    });
};

const setAuthRedirectPath = (state, action) => {
    return updateObject(state, { authRedirectPath: action.path })
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.AUTH_START: return authStart(state, action);
        case actionTypes.AUTH_START_CHECKING: return authStartChecking(state, action);
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.AUTH_FAIL: return authFail(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        case actionTypes.SET_AUTH_REDIRECT_PATH: return setAuthRedirectPath(state,action);
        case actionTypes.AUTH_CHECK_FAIL: return checkFail(state, action);
        case actionTypes.AUTH_MFA_REQUIRED: return authMfaRequired(state, action);
        case actionTypes.AUTH_MFA_CANCEL: return authMfaCancel(state, action);
        case actionTypes.AUTH_MFA_SUBMIT_FAIL: return authMfaSubmitFail(state, action);
        case actionTypes.AUTH_MFA_SETUP_READY: return authMfaSetupReady(state, action);
        default:
            return state;
    }
};

export default reducer;
